<template>
  <el-select value="" v-model="v" placeholder="请选择">
    <el-option
      v-for="node in nodes"
      :key="node.id"
      :label="node.name"
      :value="node.id"
    >
      <el-tooltip effect="dark" :content="node.description" placement="right">
        <span class="node">{{ node.name }}</span>
      </el-tooltip>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "NodesSelect",
  props: ["id"],
  data() {
    return {
      nodes: [],
      v: null
    };
  },
  beforeCreate() {
    this.$http.get("/api/v1/nodes").then(resp => {
      this.nodes = resp.data;
    });
  },
  watch: {
    id(val) {
      this.v = val;
    },
    v() {
      this.$emit("update:id", this.v);
    }
  }
};
</script>

<style scoped lang="scss">
span {
  display: block;
}
</style>
